import { Input, FormGroup, Label, FormFeedback } from 'reactstrap'
import PropTypes from 'prop-types'

const FormInput = ({
  name,
  type = 'text',
  label,
  step = '',
  onChange,
  required = false,
  onBlur,
  value,
  innerRef,
  maxLength = 255,
  disabled = false,
  error,
}) => {
  FormInput.propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func,
    maxLength: PropTypes.number,
    type: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    error: PropTypes.string,
    onBlur: PropTypes.func,
    step: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    innerRef: PropTypes.oneOfType([
      // Either a function
      PropTypes.func,
      // Or the instance of a DOM native element (see the note about SSR)
      PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    ]),
  }

  return (
    <FormGroup>
      <Label for={name}>
        {label} {required ? <b>*</b> : null}
      </Label>
      <Input
        id={name}
        type={type}
        name={name}
        step={step}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        value={value}
        innerRef={innerRef}
        maxLength={maxLength}
        disabled={disabled}
        invalid={Boolean(error)}
      />
      {!error ? null : <FormFeedback valid={false}>{error}</FormFeedback>}
    </FormGroup>
  )
}

export default FormInput
